import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "../../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/salary/slip";

export default class SalarySlipService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
